import { z } from "zod/v4";

import { URL_PARAMETER_TYPES } from "@/helpers/constants/urlParameters";

export type UrlParameterTypeValue =
  (typeof URL_PARAMETER_TYPES)[number]["value"];

export interface UrlParameter {
  id: string;
  type: string;
  customKey: string;
  value: string;
}

export const urlParameterKeySchema = z
  .string()
  .min(1, "Key is required")
  .regex(
    /^[a-zA-Z_][a-zA-Z_]*$/,
    "Key must start with a letter or underscore and contain only letters and underscores"
  );
